module.exports = __webpack_public_path__ + "img/product18p.34940810.png";